// THIS FILE IS AUTO GENERATED - do not edit!

import { forwardRef, type JSX } from 'react';

import { SvgIcon, type SvgIconProps } from '../lib/SvgIcon.js';

const UploadIconComponent = /* @__PURE__ */ forwardRef<
  SVGSVGElement,
  SvgIconProps
>((props: SvgIconProps, forwardedRef): JSX.Element => {
  return (
    <SvgIcon data-iconname="UploadIcon" ref={forwardedRef} {...props}>
      <path d="m10 3.5 4.243 4.242-1.06 1.06L10.75 6.37v6.13h-1.5V6.371L6.819 8.803l-1.06-1.061z" />
      <path d="M15.383 15.497h-11V12h-1.5l.002 3.998C2.885 16.551 3.277 17 3.76 17h12.25c.483 0 .875-.449.875-1.002L16.884 12h-1.501z" />
    </SvgIcon>
  );
});

/**
 * @public
 */
export const UploadIcon = /* @__PURE__ */ Object.assign(UploadIconComponent, {
  displayName: 'UploadIcon',
});
